/**
 * What the run panel needs to show a step's tables (AMO-299): how many rows
 * it shows before asking for the download, how a table's size reads, and
 * the file name its CSV downloads as.
 *
 * @module components/workflows/StepTables.logic
 */
import type { WorkflowStepTable } from "@amoreg/contracts";

/** Rows the panel draws per table; the download has every row the step kept. */
export const SHOWN_ROWS = 100;

/** "3 rows", "1 row, 4 more not kept": every row the table had, kept or not. */
export function tableSizeLabel(table: Pick<WorkflowStepTable, "rows" | "omittedRows">): string {
  const kept = table.rows.length;
  const rows = `${kept} ${kept === 1 ? "row" : "rows"}`;
  return table.omittedRows ? `${rows}, ${table.omittedRows} more not kept` : rows;
}

/**
 * A safe file name for a table's CSV: the table's name without characters
 * file systems refuse, never empty, ending in `.csv` once (a table named
 * after "prices.csv" downloads as "prices.csv", not "prices.csv.csv").
 */
export function tableFileName(name: string): string {
  const printable = Array.from(name, (char) => (char.charCodeAt(0) < 32 ? " " : char)).join("");
  const base = printable
    .replace(/\.csv$/iu, "")
    .replace(/[\\/:*?"<>|]+/gu, " ")
    .replace(/\s+/gu, " ")
    .trim()
    .slice(0, 100);
  return `${base || "table"}.csv`;
}
